/** Trip revenue from the stored `preSpecialRate` field. Missing stays missing. */

export const MANUAL_TRIP_REVENUE = 30;

export function readPreSpecialRate(trip) {
  if (!trip || trip.is_break) return null;
  const raw = trip.preSpecialRate ?? trip.pre_special_rate;
  if (raw == null || raw === '') return null;
  const value = Number(raw);
  return Number.isFinite(value) ? value : null;
}

/** Currency for a trip, a numeric total, or null. Missing renders as an em dash. */
export function formatTripRevenue(value) {
  const amount = value != null && typeof value === 'object'
    ? readPreSpecialRate(value)
    : (value == null || value === '' ? null : Number(value));
  if (amount == null || !Number.isFinite(amount)) return '—';
  return `$${amount.toFixed(2)}`;
}

/**
 * Sum of rates on the trips shown in a bucket.
 * Null when none of those trips have a stored rate.
 */
export function sumTripRevenue(trips) {
  let total = 0;
  let found = false;
  for (const trip of trips || []) {
    const rate = readPreSpecialRate(trip);
    if (rate == null) continue;
    total += rate;
    found = true;
  }
  if (!found) return null;
  return Math.round(total * 100) / 100;
}

/**
 * A trip dropped onto a driver from unassigned with no planner rate is a manual
 * trip worth $30. Trips that already have `preSpecialRate` keep that value, so
 * moving them between buckets only shifts the stored amount.
 */
export function stampManualAddRevenue(trip, { fromUnassigned = false } = {}) {
  if (!fromUnassigned || !trip || trip.is_break) return trip;
  if (readPreSpecialRate(trip) != null) return trip;
  return {
    ...trip,
    preSpecialRate: MANUAL_TRIP_REVENUE,
    is_manual_trip: true,
  };
}
